import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import { IconX } from '@tabler/icons-react'
import { _showToast } from "../../../../../toastHelper";
import ImageBrowse from "../../../../Common/Image/ImageBrowse";

const ArticalFrom = forwardRef(function PopularImages(props, ref) {

  const [name, setName] = useState("");
    const [date, setDate] = useState("");
    const [address, setAddress] = useState("");
  const [isOpen, setIsOpen] = useState("");
  const [imageKey, setImageKey] = useState(null);
  const [errors, setErrors] = useState({});
  const imageRef = useRef();

  useEffect(() => {
    if (props.data) {
      setName(props.data.name);
      setIsOpen(props.data.show);
      setImageKey(props.data.imageKey);

      imageRef?.current?.setThumbnail(props.data.image && props.data.image != "" ? props.data.image : null);
      imageRef?.current?.setFileContent(props.data.imageFile);
    }
  }, [props.data])

  useEffect(() => {
    setIsOpen(props.data.show);
  }, [props.data.show]);


  const validate = () => {
    const errors = {};

    if (!name || (name && name.trim() == "")) {
      errors.name = "Name is required";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  }

  const getData = () => {
    return {
      name: name,
      date: date,
      address: address,
      image: imageRef?.current?.getThumbnail() ?? null,
      imageFile: imageRef?.current?.getImageFile() ?? null,
      imageKey: imageKey
    };

  };

  useImperativeHandle(ref, () => ({
    getData: getData,
    validate: validate
  }));

  return (
    <div className="card accordion-item ">
      <h2 className="accordion-header">
        <button type="button"
          onClick={() => props.showHidePople(props.index)}
          className={`accordion-button ${isOpen ? "" : "collapsed"}`}>
          {name}
        </button>
      </h2>

   

       <form>
          <div className="row g-3">
            <div className="col-sm-6">
              <label className="form-label" htmlFor="section2Name">
               Title
              </label>
              <input
                type="text"
                id="section2Name"
                name="section2Name"
                placeholder="Please enter the main title here"
                className={`form-control ${errors.name ? "is-invalid" : ""
                  }`}
                value={name}
               
              />
            
            </div>
            <div className="col-sm-6">
              <label className="form-label" htmlFor="section2Name">
               Date
              </label>
              <input
                type="date"
                id="section2Name"
                name="section2Name"
                placeholder="Please enter the main title here"
                className={`form-control ${errors.date ? "is-invalid" : ""
                  }`}
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
              {errors.date && (
                <div className="invalid-feedback"></div>
              )}
            </div>


            
            <div className="col-sm-6">
            <div className="row ">
              <div >
                <label className="form-label" htmlFor="image">
                   Image <small className="text-gray">(Max Allowable File Size: 1MB,Image Dimensions: 424px x 220px)</small>
                </label>
                <ImageBrowse
                  elementId={"peopleImage-" + props.index} ref={imageRef} imageType="artical"
                  imageKey={imageKey} setImageKey={setImageKey} imageDelete={props.imageDelete} />
              </div>
            </div>
            <div className="col-12 ">
              <button type="button" className="btn btn-label-danger"
                onClick={() => props.deletePeople(props.index)}>
                <IconX className="me-1" size={16} />
                <span className="align-middle">Delete</span>
              </button>
            </div>
            </div>
            <div className="col-sm-6">
              <label className="form-label" htmlFor="section2TagLine">
              description
              </label>
              <textarea
                name="section2TagLine"
                id="section2TagLine"
                className="form-control"
                placeholder="Please enter the sub heading description here"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                style={{ height: "200px", resize: "none" }}
              />
            </div>
          </div>
        </form>
    </div>
  )
});

export default ArticalFrom